export const MAX_QUESTIONS = 26;
export const ASSESSMENT_API_BASE = `/api/mp-assessment/`;
export const LOCAL_ASSESSMENT_API_BASE = `http://localhost:8081/mp-assessment/`;

export const DELEGATOR_API_BASE = `/api/prp-delegator/mp/`;
export const LOCAL_DELEGATOR_API_BASE = `http://localhost:8080/prp-delegator/mp/`;

export const FEATURE_API_BASE = '/api/prp-feature';
export const LOCAL_FEATURE_API_BASE = 'http://localhost:8082/prp-feature';
export const ERROR_API = '/api/prp-delegator/notify/avi';
export const ERROR_API_LOCAL = 'http://localhost:8080/prp-delegator/notify/avi';

export const MY_PRIORITIES_APP_NAME_FRENCH = 'mespriorites';

export const LOCALE_EN_US = 'en_US';
export const LOCALE_EN_CA = 'en_CA';
export const LOCALE_FR_CA = 'fr_CA';
